import { StateCreator } from 'zustand';
import produce from 'immer';
import { runningTradeConfig } from 'constants/datafeed';
import { State } from './state';

export interface Actions {
  setClearData: () => void;
  addBatch: (key: RunningTradeKey, batch: RunningTradeItem[], isFilterBatch?: boolean) => void;
  setIsQueue: (key: RunningTradeKey) => void;
  shiftBatch: (key: RunningTradeKey) => void;
  setActive: (key: RunningTradeKey, value: boolean) => void;
  setFilter: (key: RunningTradeKey, value: string) => void;
  clearData: (key: RunningTradeKey) => void;
  play: (key: RunningTradeKey) => void;
  pause: (key: RunningTradeKey) => void;
}

export const actions: StateCreator<State & Actions, [], [], Actions> = (set) => ({
  setClearData: () => {
    set((state) => produce(state, (draft) => {
      Object.keys(draft.runningTrade).forEach((rtKey: RunningTradeKey) => {
        if (draft.runningTrade[rtKey].isActive) {
          draft.runningTrade[rtKey].data = [];
          draft.runningTrade[rtKey].batch = [];
        }
      });
    }));
  },
  addBatch: (key, batch) => {
    set((state) =>
      produce(state, (draft) => {
        const { filter, isPaused } = draft.runningTrade[key];
        if (!isPaused) {
          const newBatch =
            filter && filter !== '*'
              ? batch.filter((value) => value.stock === filter)
              : batch;

          draft.runningTrade[key].batch = [
            ...state.runningTrade[key].batch,
            ...newBatch,
          ].slice(-runningTradeConfig[key].limit);
        }
      }));
  },
  /** setIsQueue will set isQueue value to true
   * if batch is not empty and runningtrade active, vice versa */
  setIsQueue: (key) => {
    set((state) =>
      produce(state, (draft) => {
        const rtInstance = draft.runningTrade[key];
        rtInstance.isQueue = !!rtInstance.batch[0] && rtInstance.isActive;
      }));
  },
  shiftBatch: (key) => {
    set((state) =>
      produce(state, (draft) => {
        const rtInstance = draft.runningTrade[key];
        const { data, batch } = rtInstance;
        const [dataToInsert] = batch;
        if (!dataToInsert) return;
        if (
          rtInstance.filter === '*' ||
          rtInstance.filter === dataToInsert.stock
        ) {
          const newLength = data.unshift(dataToInsert);
          if (newLength > runningTradeConfig[key].limit) data.pop();
        }
        batch.splice(0, 1);
      }));
  },
  setActive: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.runningTrade[key].isActive = value;
      }));
  },
  setFilter: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.runningTrade[key].filter = value;
      }));
  },
  clearData: (key) => {
    set((state) => produce(state, (draft) => {
      draft.runningTrade[key].data = [];
      draft.runningTrade[key].batch = [];
    }));
  },
  play: (key) => {
    set((state) => produce(state, (draft) => {
      draft.runningTrade[key].isPaused = false;
    }));
  },
  pause: (key) => {
    set((state) => produce(state, (draft) => {
      draft.runningTrade[key].isPaused = true;
      draft.runningTrade[key].batch = [];
    }));
  },
});
